import { CSSProperties } from "react";
import {
  DetailDrawerLineItem,
  DetailDrawerSectionTitle,
} from "../DetailsDrawer";

export function List({
  items,
  className,
  style,
}: {
  items: any[];
  className?: string;
  style?: CSSProperties;
}) {
  return items.map((item, index) => (
    <div key={index} className={className} style={style}>
      <DetailDrawerSectionTitle title={item.title} className="mb-4" />

      <div className="flex flex-col gap-2">
        {item.items?.map((_item: any, _index: any) => (
          <DetailDrawerLineItem
            key={_index}
            title={_item.label}
            value={_item.value}
            className="!items-start"
          />
        ))}
      </div>
    </div>
  ));
}
